import { useContext } from 'react';
import { MyContext } from './AppointmentContext';

const useAppointmentContext = () => {
  const context = useContext(MyContext);
  if (!context) {
    throw new Error('useMyContext must be used within a MyProvider');
  }
  return context;
};

export default useAppointmentContext;
